export const TEMPLATES = [
  {
    name: 'Disposition Théâtre',
    description: 'Rangées de chaises face à un podium, idéal pour conférences',
    minCapacity: 20,
    maxCapacity: 100,
  },
  {
    name: 'Disposition Classe',
    description: 'Tables et chaises en rangées, idéal pour formations',
    minCapacity: 10,
    maxCapacity: 40,
  },
  {
    name: 'Disposition en U',
    description: 'Tables en forme de U, favorise les échanges',
    minCapacity: 8,
    maxCapacity: 30,
  },
  {
    name: 'Disposition Cocktail',
    description: 'Tables hautes debout, ambiance conviviale',
    minCapacity: 20,
    maxCapacity: 80,
  },
  {
    name: 'Disposition Banquet',
    description: 'Tables rondes pour repas assis',
    minCapacity: 20,
    maxCapacity: 60,
  },
  {
    name: 'Disposition Réunion',
    description: 'Table centrale rectangulaire ou ovale',
    minCapacity: 4,
    maxCapacity: 20,
  },
  {
    name: 'Autre disposition',
    description: 'Configuration sur mesure selon les besoins',
    minCapacity: null,
    maxCapacity: null,
  },
];
